import { Component } from '@angular/core';
import { IconComponent } from 'src/app/ui-design-library/icon/icon.component';

@Component({
  selector: 'fnsr-footer',
  standalone: true,
  imports: [IconComponent],
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.scss']
})
export class FooterComponent {

}
